import PropTypes from 'prop-types';

export const resourceType = PropTypes.shape({
  _id: PropTypes.string,
  fee: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  onCampus: PropTypes.string,
  description: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.object),
  url: PropTypes.string,
  'non-BU': PropTypes.string,
  p: PropTypes.arrayOf(PropTypes.any),
  phone: PropTypes.string,
  imgName: PropTypes.string,
  done: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  contactName: PropTypes.string,
  address: PropTypes.string,
  buOffice: PropTypes.string,
  email: PropTypes.string,
  forStudents: PropTypes.string,
  name: PropTypes.string,
  notes: PropTypes.string,
});

export const tagType = PropTypes.shape({
  _id: PropTypes.string,
  display: PropTypes.string,
  matches: PropTypes.number,
  p: PropTypes.array,
  value: PropTypes.string,
});



// WEBPACK FOOTER //
// ./src/types.js